var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"marker-container",on:{"click":_vm.onClick}},[_c('svg',{attrs:{"viewBox":"0 0 36 36"}},[_c('circle',{staticClass:"marker-circle",attrs:{"cx":"18","cy":"18","r":"6","fill":_vm.color}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }